module.exports = __webpack_public_path__ + "static/img/zhaopin_header.797749a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/zhaopin_header.jpg
// module id = oH8h
// module chunks = 1